import AxiosInstance from "./api";

export const PayrollDistributionScheduleService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/payroll-distribution-schedule", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/payroll-distribution-schedule/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/payroll-distribution-schedule", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/payroll-distribution-schedule/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/payroll-distribution-schedule/${id}`);
  },
};
